// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_ma-0";
export var buttonContainer = "_ma-3";
export var cancelButton = "_ma-4";
export var headerSection = "_ma-6";
export var headerTitle = "_ma-9";
export var messageSideLeft = "_ma-1";
export var messageSideRight = "_ma-2";
export var orderNumberContainer = "_ma-7";
export var orderNumberLabel = "_ma-8";
export var submitButton = "_ma-5";